<div class="overlaySpinner" *ngIf="showSpinner">
  <mat-progress-spinner class="querySpinner" mode="indeterminate"></mat-progress-spinner>
</div>
